
import {auth, functions } from "@/scripts/firebase";
import {EmailAuthProvider, checkActionCode,isSignInWithEmailLink,signInWithEmailLink,linkWithCredential,applyActionCode} from "firebase/auth"
import {ModalConfirmProps,NoticeProps } from "@/scripts/datatypes";
import PhoneAuth from "@/components/PhoneAuth.vue"
import EmailAuth from "@/components/EmailAuth.vue"
import { Component, Mixins, Watch  } from "vue-property-decorator";
import { ValidationObserver } from 'vee-validate'
import ModalConfirm from "@/components/ModalConfirm.vue"
import * as Sentry from "@sentry/browser";
import Common from '../mixins/common';
import { httpsCallable } from "@firebase/functions"
import { SetLineLinkArg, SetLineLinkRes,CheckLineTokenArg} from "@/common-datatypes";

@Component({
  components: {
    ModalConfirm,
    PhoneAuth,
    EmailAuth
  }
})

export default class ActionLink extends Mixins(Common) {
  isLoading = false
  showSignInWithEmailLink = false
  showLinkWithEmail = false
  showLineLink = false
  showSignInRedirect = false
  showModal = false
  showPhoneAuth = false
  showEmailAuth = false
  email =  ''
  restoredEmail = ''
  actionLinkResult = {} as NoticeProps
  secondActionResult = {} as NoticeProps

  modalConfirmProps?: ModalConfirmProps

  lineLinkData?: SetLineLinkRes

  lineActionLinkUrl = ''
  redirectUrl = ''

  invitationActionLinkUrl = ''
  /*
	showInvitationWithPhone = false
  showInvitationWithEmail = false
  */

  get signInWithEmailLinkObserver(){
    return this.$refs.signInWithEmailLinkValidationObserver as InstanceType<typeof ValidationObserver>
  }

  get linkWithEmailObserver(){
    return this.$refs.linkWithEmailValidationObserver as InstanceType<typeof ValidationObserver>
  }

  get requiredSignIn(){
    return !!(this.$store.getters.actionLinkAction === 'linkWithEmail' && this.$store.getters.actionLinkUid !== this.$store.getters.uid )
  }

  get modeName(){
    if(this.$store.getters.actionLinkAction){
      return this.$t(`actionLink.action.${this.$store.getters.actionLinkAction}`) as string
    }else if(this.actionLinkMode){
      return this.$t(`actionLink.mode.${this.actionLinkMode}`) as string
    }
    return ''
  }

  title = ''

  get signIn(){
    return !! this.$store.getters.uid
  }

  @Watch('signIn')
  async changeSignIn(value: boolean){
    if(value && (this.$store.getters.actionLinkMode === 'redirect' || this.$store.getters.actionLinkAction === 'redirect' )){
      this.showSignInRedirect = false
      await this.redirect()
    }
  }

  get actionLinkMode(){
    if(typeof this.$store.getters.actionLinkMode === 'string'){
      return this.$store.getters.actionLinkMode
    }
    return null
  }

  get numSchools(): number {
    return this.$store.getters.numSchools
  }

  async created(){
    let timer: number
    this.$store.commit("setLoading",true);
    this.isLoading = true

    this.$watch('modeName', async (modeName: string) => {
       clearTimeout(timer)
       
      if(modeName === ''){
        this.title =  this.$t('message.welcome',{m: 'MARITO'}) as string
        timer = window.setTimeout(() => {
          this.title = this.$t('message.error') as string
        },1000);
      }else{
        this.title = modeName
      }
    },{immediate: true})

    const unwatch = this.$watch('actionLinkMode', async (mode: string | null) => {
        if(mode === null){
          return
        }
        try{
          switch(mode){
            case 'signIn':
              if(! isSignInWithEmailLink(auth,window.location.href)){
                throw new Error()
              }
              switch (this.$store.getters.actionLinkAction) {
                //sign up by email
                case 'signUp':
                  await this.handleSignUpWithEmailLink()
                  break
                //link with email
                case 'linkWithEmail':
                  await this.handleLinkWithEmail()
                  break
                case 'updateEmail':
                  await this.handleUpdateEmail()
                  break
                case 'lineLink':
                  await this.handleSignInWithEmailLink()
                  break
                case 'redirect':
                  await this.handleSignInWithEmailLink()
                  break
                default:
                  await this.handleSignInWithEmailLink()
              }
              break
            case 'recoverEmail':
              await this.handleRecoverEmail()
              break
            case 'lineLink':
              await this.handleLineLink()
              break
            case 'redirect':
              await this.handleRedirect()
              break
            default:
              this.actionLinkResult = {
                message: 'authentication.errorCode.auth/invalid-action-code' as string,
                isShow: true,
                duration: 0,
                type: {'is-danger': true}
              }
          }
        }catch(error){
          const errorCode = this.$getErrorCode(error)
          this.actionLinkResult = {
            message: this.$getErrorMessageKey(errorCode,'authentication.errorCode.auth/invalid-action-code'),
            isShow: true,
            duration: 0,
            type: {'is-danger': true}
          }
        }finally{
          this.$store.commit("setLoading",false);
          this.isLoading = false
          unwatch()
        }
      },{immediate: true})
  }

  private async handleLineLink(){
    try{
      this.secondActionResult = {
        message: 'actionLink.setting',
        isShow: true,
        duration: 0,
        type: {'is-info': true}
      }

      const checkLineToken = httpsCallable(functions,'checkLineToken')
      const token = this.$store.getters.actionLinkToken
      const checkLineTokenRes = await checkLineToken({type: 'lineLink',value: token} as CheckLineTokenArg) as {data: true}

      if(checkLineTokenRes.data){
        await auth.signOut()
        this.lineActionLinkUrl = location.origin + location.pathname + '?action=lineLink&token=' + token
        this.showLineLink = true
        this.secondActionResult = {
          isShow: false
        }
      }
    }catch(error){
      Sentry.captureException(error)
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('actionLink.errorLineLink') as string
      const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode,'actionLink.expiredLink'))

			const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.secondActionResult = {
        message: errorMessage,
        isShow: true,
        duration: 0,
        type: {'is-danger': true}
      }
    }
  }

  private async handleRedirect(){
    this.redirectUrl = this.$store.getters.actionLinkContinueUrl + '?action=redirect'
    this.showSignInRedirect = true
  }

  async lineLink(){
    try{
      this.secondActionResult = {
        message: 'actionLink.setting',
        isShow: true,
        duration: 0,
        type: {'is-info': true}
      }
      this.$store.commit("setLoading",true);
      this.isLoading = true
      const setLineLink = httpsCallable(functions,'setLineLink')
      const setLineLinkData = await setLineLink({
        token: this.$store.getters.actionLinkToken,
        schoolId: this.$store.getters.schoolId
      } as SetLineLinkArg) 
      
      this.lineLinkData = setLineLinkData.data as SetLineLinkRes

      Sentry.captureMessage(JSON.stringify(this.lineLinkData))

      this.modalConfirmProps = {
        title: 'actionLink.action.lineLink',//,,
        message: this.$t('actionLink.linkWithLINE',{
          schoolName: this.lineLinkData.schoolName,
          lineAccountName: this.lineLinkData.displayName
        }) as string,
        isLoading: false
      }

      this.showModal = true
    }catch(error) {
      console.table(error)
      Sentry.captureException(error)
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('actionLink.errorLineLink') as string
      const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode))

			const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.secondActionResult = {
        message: errorMessage,
        isShow: true,
        duration: 0,
        type: {'is-danger': true}
      }
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  goToEndpoint(confirm: boolean){
    if(! confirm || ! this.lineLinkData?.endpointUrl){
      this.showModal = false
      this.showLinkWithEmail = false
      this.showLineLink = false
      this.secondActionResult = {
        message: 'actionLink.canceledLineLink',
        isShow: true,
        duration: 0,
        type: {'is-info': true}
      }
      return
    }
    window.location.href = this.lineLinkData.endpointUrl
  }

  private async signInWithEmailLink(){
    try{
      this.$store.commit("setLoading",true);
      this.isLoading = true

      if(this.showSignInWithEmailLink && ! await this.signInWithEmailLinkObserver.validate()){
        return
      }

      await signInWithEmailLink(auth,this.email, window.location.href)

      window.localStorage.removeItem('emailForSignIn');
      
      this.actionLinkResult = {
        message: 'emailAuth.success',
        isShow: true,
        duration: 0,
        type: {'is-info': true}
      }

      /*  移動 */
      if(this.$store.getters.actionLinkAction === 'lineLink'){
        await this.lineLink()
      }else if(this.$store.getters.actionLinkAction === 'signUp'){
        await this.$router.push({name: 'introduction'})
      }else if(this.$store.getters.invited){
        await this.$router.push({name: 'enterSchool'})
      }else{
        //TODO: go to dashboard finally.
        if(this.numSchools == 0){
          await this.$router.push({ name: 'account'})
        }else{
          await this.$router.push({ name: 'dashboard'})//schedule
        }
      }

    }catch(error) {
      console.table(error);
      const errorCode = this.$getErrorCode(error)

      this.secondActionResult = {
        message: this.$getErrorMessageKey(errorCode),
        isShow: true,
        duration: 0,
        type: {'is-danger': true}
      }
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
      this.showSignInWithEmailLink = false
    }
  }

  private async handleSignUpWithEmailLink(){
    await auth.signOut()
    const email = window.localStorage.getItem('emailForSignIn') || '';

    if(email){
      this.email = email
      console.log('handleSignUpWithEmailLink')
      await this.signInWithEmailLink()
    }else{
      this.showSignInWithEmailLink = true
    }
  }

  private async redirect(){
    const continueUrl = new URL(this.$store.getters.actionLinkContinueUrl)
    if(window.location.origin === continueUrl.origin){
      const path = continueUrl.pathname.replace(/$\//,'')
      await this.$router.push({path: path})
    }else{
      window.location.href = continueUrl.href
    }
  }

  private async handleLinkWithEmail(){
     if(! this.$store.state.actionLink.uid){
      throw new Error()
    }
    console.log('handleLinkWithEmail')
    const email = window.localStorage.getItem('emailForSignIn') || '';

    if(email){
      this.email = email
    }
    this.showLinkWithEmail = true
  }

  private async handleUpdateEmail(){
    const email = window.localStorage.getItem('emailForSignIn') || '';
    if(email){
      this.email = email
    }
    this.showSignInWithEmailLink = true
  }

  public async linkWithEmail(){
    try{
      this.$store.commit("setLoading",true);
      this.isLoading = true

      if(! await this.linkWithEmailObserver.validate()){
        return
      }

      if(! auth.currentUser || this.requiredSignIn){
        return
      }

      const credential = EmailAuthProvider.credentialWithLink(this.email,location.href);
      const userCredential =  await linkWithCredential(auth.currentUser,credential)
      
      this.$store.commit("setUser",userCredential.user)

      window.localStorage.removeItem('emailForSignIn');
      
      this.actionLinkResult = {
        message: 'actionLink.linkedWithEmail',
        isShow: true,
        duration: 0,
        type: {'is-success': true}
      }

      this.showLinkWithEmail = false

    }catch(error) {
      console.table(error);
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('actionLink.errorLinkWithEmail') as string
      const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode))

			const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1

      this.secondActionResult = {
        message: errorMessage,
        isShow: true,
        duration: 0,
        type: {'is-danger': true}
      }
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }


  private async handleSignInWithEmailLink() {
    const email = window.localStorage.getItem('emailForSignIn') || ''
    console.log(email)
    if(email){
      this.email = email
      await this.signInWithEmailLink()
    }else{
      this.showSignInWithEmailLink = true
    }
  }

  private async handleRecoverEmail() {
    const info = await checkActionCode(auth,this.$store.getters.actionLinkCode)
    this.restoredEmail = info.data.email as string

    // Revert to the old email.
    await applyActionCode(auth,this.$store.getters.actionLinkCode)

    this.actionLinkResult = {
      message: this.$t('actionLink.recoverdEmail') as string,
      isShow: true,
      duration: 0,
      type: {'is-info': true}
    }
  }

  destroyed(){
    this.$store.commit('setActionLink',null)
  }

}
